export default class LockOnSubmit {
  constructor() {
    if (!this.vars()) return false;
    this.setupEvents();
  }

  vars() {
    this.selectors = {
      form: 'data-los',
      button: 'data-los-btn',
    };

    this.forms = Array.from(document.querySelectorAll(`[${this.selectors.form}]`));

    if (!this.forms.length) return false;

    return true;
  }

  setupEvents() {
    this.forms.forEach((form) => form.addEventListener('submit', (e) => {
      this.handleSubmit(form);
    }));
  }

  handleSubmit(form) {
    const btn = form.querySelector(`[${this.selectors.button}]`);
    // form.setAttribute('action', '');
    if (btn) {
      btn.disabled = true;
      btn.innerText = "Wysyłam";
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/LockOnSubmit.js